const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

/** Visita de pantalla para el panel interno. No usa cookies ni Google Analytics. */
export function reportarVista(pathname) {
  if (typeof window === 'undefined' || !pathname) return;
  const pantalla = String(pathname).split('?')[0].split('#')[0];
  if (!pantalla.startsWith('/')) return;
  const headers = { 'Content-Type': 'application/json' };
  try {
    const token = localStorage.getItem('accessToken');
    if (token) headers.Authorization = `Bearer ${token}`;
  } catch {
    /* sin almacenamiento, la visita queda anónima */
  }
  fetch(`${API_URL}/uso/vista`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ pantalla }),
    keepalive: true,
  }).catch(() => {});
}
